export default __webpack_public_path__ + "static/media/assessments.53d35825.svg";